import { BodyText, HeadlineText } from '@calendly/ui/components/typography';
const headerContainerCss = "huanuh6";
const titleTextContainerCss = "tvpvhsv";
const subtitleTextContainerCss = "s1hcikhz";
export const Header = ({
  title,
  subtitle
}) => <div className={headerContainerCss}>
    <div className={titleTextContainerCss}>
      <HeadlineText size="medium">
        {title}
      </HeadlineText>
    </div>
    <div className={subtitleTextContainerCss}>
      <BodyText color="muted" size="large">
        {subtitle}
      </BodyText>
    </div>
  </div>;

require("./Header.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./Header.js");